import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-modal-header-card',
  templateUrl: './modal-header-card.component.html',
  styleUrls: ['./modal-header-card.component.scss'],
})
export class ModalHeaderCardComponent implements OnInit {
  @Input() title: string;

  @Output() closeModal = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  public onCloseClicked(): void {
    this.closeModal.emit();
  }
}
